import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class ReviewChatForm {
  public score: number[] = [];

  public rules: { [key: string]: FormValidationFunction[] } = {
    score: [
      (v: number) => !!v || 'Score is required',
    ],
  };
}
